// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__CExu+","default":"Modal_default__L2a0o"};